import { selectIsModalOpen } from "../../selectors/selectModalTabId";
import { mapCoopInvitePlayerError } from "../cooperative/mapCoopInvitePlayerError";
import { IdModal } from "../modals/IdModal";
export var checkForCoopInvitePlayerError = function (path) { return function (action, state$) {
    if (selectIsModalOpen(state$.value, IdModal.PlayerProfile) &&
        mapCoopInvitePlayerError.has(action.statusCode)) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/errors/checkForCoopInvitePlayerError.ts
// module id = 1845
// module chunks = 3